import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { UserSchema } from "../../_offline/models/user.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class UserDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<UserSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.USER.GET_ALL, this.tenantId);
  }

  getOne(id: string): Observable<UserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.USER.GET_ONE, this.tenantId, id);
  }

  putAll(subjects: UserSchema[]): Observable<UserSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.USER.PUT_ALL, subjects);
  }
}
